<template>
  <div v-if="order" :id="`order_${order.id}`" class="z-border-red" style="margin-bottom: 10px">
    <v-layout>
      <v-flex xs10>
        <div class="ma-2">
          <v-layout>
            <v-flex xs6 sm3>
              <v-checkbox
                :input-value="isCheck"
                :label="`Order No. ${order.id}`"
                style="display: inline-block; margin: 0"
                @change="assignCb(order.id)"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs6 sm9 style="align-self: center;">
              <small v-if="order.created_by_type === 'admin'" class="openBill-border">{{
                order.created_by_name
              }}</small>

              <small v-if="order.is_edited_by_user" class="openBill-border">{{
                $t('customer_address_edited')
              }}</small>

              <small
                v-if="order.payment === 'fbpay'"
                style="background-color: #eef8fb;"
                class="openBill-border"
                >{{ $t('meta_pay_invoice') }}</small
              >
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs2>
        <div class="ma-2" style="display: flex; float: right;">
          <template v-if="order.printed_at">
            <v-icon class="mr-1" color="primary">fa fa-print</v-icon>
          </template>
          <template v-if="order.userid == 'salepage'">
            <v-icon class="mr-1" small color="primary">storefront</v-icon>
          </template>
          <template v-if="order.app == 'facebook'">
            <i class="fab fa-facebook-square" style="color: #3c5a99"></i>
          </template>
          <template v-else-if="order.app == 'line'">
            <i class="fab fa-line" style="color: #00c300"></i>
          </template>
          <template v-else-if="order.app == 'instagram' || order.app == 'instagram'">
            <i class="fab fa-instagram" style="color: #C13584"></i>
          </template>
          <template v-else-if="order.app == 'google' || order.app == 'google'">
            <i class="fab fa-google" style="color: #F4B400"></i>
          </template>
          <template v-else-if="order.app == 'whatsapp' || order.app == 'whatsapp'">
            <i class="fab fa-whatsapp" style="color:#00c300"></i>
          </template>
          <template v-if="order.egg_crm_phone_no !== null">
            <img style="height: 16px" src="/static/img/egg.png" />
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm7>
        <div style="border-right: 1px solid #eee; height: 100%">
          <template v-if="typeof orderDetailFormat == 'string'">
            <div class="pa-2">
              <nl2br tag="div" :text="order.productdetail"></nl2br>
            </div>
          </template>
          <template v-else-if="typeof orderDetailFormat == 'object'">
            <template v-for="(product, oindex) in orderDetailFormat">
              <template
                v-if="
                  !['740558886346101'].includes(selectedBot.pageid) ||
                    (['740558886346101'].includes(selectedBot.pageid) &&
                      (oindex < 3 || showProductDetail == order.id))
                "
              >
                <v-layout wrap :key="'order_' + oindex">
                  <v-flex sm1 xs2>
                    <div class="ma-2">
                      <template v-if="!product.photourl">
                        <v-img
                          aspect-ratio="1"
                          :src="'/static/img/assets/_global/default-photo.png'"
                        >
                        </v-img>
                      </template>
                      <v-img
                        v-else
                        :src="product.photourl"
                        aspect-ratio="1"
                        alt
                        class="grey lighten-2"
                      >
                        <template v-slot:placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </v-flex>
                  <v-flex sm7 xs6 style="word-break: break-word">
                    <div class="mt-2 mx-2 mb-1" v-if="product.name !== 'Purchase'">
                      {{ product.name }} x {{ product.quantity }}
                      <template v-if="product.option">({{ product.option }})</template>
                    </div>
                    <div class="mx-2" v-if="product.sku">
                      <small>{{ product.sku }}</small>
                    </div>
                    <div
                      v-if="product.addon_json && product.addon_json.text"
                      class="pl-3 warning--text"
                    >
                      <nl2br tag="span" :text="product.addon_json.text" />
                    </div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <div class="ma-2">{{ formatCurrency(product.price, order.currency_code) }}</div>
                  </v-flex>
                </v-layout>
                <v-divider v-if="oindex < productsCount - 1" :key="oindex"></v-divider>
              </template>
            </template>
            <div class="text-xs-right" v-if="productsCount > 10">
              <v-pagination
                small
                v-if="
                  ['740558886346101'].includes(selectedBot.pageid) &&
                    (oindex < 3 || showProductDetail == order.id)
                "
                :length="pageCountItemOrder"
                v-model="pageNumberData"
              ></v-pagination>
            </div>
            <template v-if="['740558886346101'].includes(selectedBot.pageid) && productsCount > 3">
              <v-btn
                style="width: 100%"
                class="ma-0"
                depressed
                color="primary lighten-3"
                small
                @click="
                  $emit('onShowProductDetail', showProductDetail == order.id ? null : order.id)
                "
              >
                {{
                  $t(showProductDetail == order.id ? 'Show less products' : 'Show more products')
                }}
                ({{ productsCount }})
                <v-icon>{{ showProductDetail == order.id ? 'expand_less' : 'expand_more' }}</v-icon>
              </v-btn>
            </template>
            <template v-if="order.egg_crm_products && order.egg_crm_products.product">
              <v-divider></v-divider>
              <v-layout wrap>
                <v-flex sm1 xs2>
                  <div class="ma-2">
                    <v-img
                      :src="
                        order.egg_crm_products.product.photourl ||
                          order.egg_crm_products.data.rewardImagePath
                      "
                      aspect-ratio="1"
                      alt
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0> </v-layout>
                      </template>
                    </v-img>
                  </div>
                </v-flex>
                <v-flex sm7 xs6 style="word-break: break-word">
                  <div class="ma-2">
                    {{ order.egg_crm_products.product.name }} x
                    {{ order.egg_crm_products.data.quantity }}
                  </div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <div class="ma-2">Free</div>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
            </template>
          </template>

          <div>
            <v-layout v-if="order.egg_crm_phone_no">
              <v-flex>
                <div class="pa-2">{{ $t('หมายเลขสมาชิก') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{ order.egg_crm_phone_no }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.total != null">
              <v-flex>
                <div class="pa-2">{{ $t('Subtotal') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{
                    formatCurrency(
                      order.total - (order.shippingcharge ? order.shippingcharge : 0),
                      order.currency_code
                    )
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.shippingcharge != null">
              <v-flex>
                <div class="pa-2">{{ $t('Shipping fee') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{
                    formatCurrency(order.shippingcharge, order.currency_code)
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Discount') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color"
                    >-{{ formatCurrency(order.discount, order.currency_code) }}</span
                  >
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="jsonValue != null && jsonValue.promocode">
              <v-flex>
                <div class="pa-2">{{ $t('Coupon Code') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{ jsonValue.promocode }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="order.vat_amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('Vat') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{
                    formatCurrency(order.vat_amount, order.currency_code)
                  }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="order.amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('Total') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{
                    formatCurrency(order.amount, order.currency_code)
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-divider />

          <v-layout>
            <v-flex class="pa-2">
              <img
                v-if="shippingType && shippingType.name == 'normal'"
                src="/static/img/assets/payment/normal_charge_logo.png"
                alt
                class="responsive-img"
                style="max-height: 50px"
              />
              <img
                v-else-if="shippingType && shippingType.name == 'ems'"
                src="/static/img/assets/payment/ems_charge_logo.png"
                alt
                class="responsive-img"
                style="max-height: 50px"
              />
              <img
                v-else-if="shippingType && shippingType.name == 'kerry'"
                src="/static/img/assets/payment/kerry_charge_logo.png"
                alt
                class="responsive-img"
                style="max-height: 50px"
              />
              <template v-else>
                <template v-if="shippingType && shippingType.name">
                  <img
                    @error="onImageLoadFailure($event)"
                    :src="'/static/img/assets/payment/' + shippingType.name + '_logo.png'"
                    alt
                    class="responsive-img"
                    style="max-height: 50px"
                  />
                  <div v-if="shippingType.name == 'cod_charge'" class="caption">
                    {{ $t('cod_charge') }}
                  </div>
                </template>
              </template>
            </v-flex>
            <v-flex class="pa-2 text-xs-right">
              <multiselect
                v-model="shippingValue"
                :options="shippingOptions"
                label="name"
                selectLabel
                selectedLabel
                :allow-empty="false"
                deselect-label
                track-by="name"
                @select="onSelectShipping"
              >
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__title">
                    <template v-if="shippingType.name && shippingType.name.includes('other')">{{
                      shippingType[4] ? shippingType[4] : $t(shippingType.name)
                    }}</template>
                    <template v-else>{{ $t(shippingType.name) }}</template>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span class="option__title">
                      <template v-if="props.option.name && props.option.name.includes('other')">{{
                        props.option[4] ? props.option[4] : $t(props.option.name)
                      }}</template>
                      <template v-else>{{ $t(props.option.name) }}</template>
                    </span>
                  </div>
                </template>
              </multiselect>
              <!-- <v-layout justify-center align-center style="height: 100%" row>
                <v-flex>
                  <template v-if="shippingType.includes('other')">{{ shippingValue }}</template>
                  <template v-else>{{ $t(shippingType) }}</template>
                </v-flex>
              </v-layout> -->
            </v-flex>
          </v-layout>
          <v-divider />
          <v-layout>
            <v-flex class="pa-2">
              <div class="caption">
                <template v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  >หมายเลขเดอะวัน</template
                >
                <template v-else>{{ $t('Remark') }}</template>
              </div>
              <editable
                v-if="!order.remark.includes('{|}')"
                v-model="order.remark"
                :filter="'text'"
                :type="'text'"
                @edited="$emit('updateOrder', { type: 'save', order })"
              ></editable>
            </v-flex>
          </v-layout>
          <v-layout v-if="$store.state.drJillPage.includes(selectedBot.pageid)">
            <v-flex class="pa-2">
              <div class="caption">
                <template>{{ $t('รหัสพนักงาน') }}</template>
              </div>
              <editable
                v-model="order.employeeId"
                :maxLengthRemark="128"
                :filter="'text'"
                :type="'text'"
                @edited="$emit('updateOrder', { type: 'save', order })"
              ></editable>
            </v-flex>
          </v-layout>
          <template v-if="selectedBot.page_receipt_status">
            <v-layout v-if="tax_address_json">
              <v-flex class="pa-2">
                <div class="caption">
                  <template>{{ $t('Date (Receipt/ Tax invoice)') }}</template>
                </div>
                <editable
                  v-model="tax_address_json.invoice_date"
                  :filter="'text'"
                  :type="'date'"
                  @edited="editTaxAddress()"
                ></editable>
              </v-flex>
              <v-flex>
                <div class="pa-2">
                  <div style="text-align: right">
                    <SendInvoiceBTN
                      :order="order"
                      @sendInvoicePDF="sendInvoicePDF"
                      style="display: inline-block"
                    ></SendInvoiceBTN>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="tax_address_json && tax_address_json.tax_name">
              <v-flex class="pa-2">
                <div class="caption">
                  <template>{{ $t('name') }}</template>
                </div>
                <editable
                  v-model="tax_address_json.tax_name"
                  :filter="'text'"
                  :type="'text'"
                  @edited="editTaxAddress()"
                ></editable>
              </v-flex>
            </v-layout>
            <v-layout v-if="tax_address_json && tax_address_json.tax_address">
              <v-flex class="pa-2">
                <div class="caption">
                  <template>{{ $t('Address (Receipt/ Tax invoice)') }}</template>
                </div>
                <editable
                  v-model="tax_address_json.tax_address"
                  :filter="'text'"
                  :type="'text'"
                  @edited="editTaxAddress()"
                ></editable>
              </v-flex>
            </v-layout>
            <v-layout v-if="tax_address_json && tax_address_json.tax_id">
              <v-flex class="pa-2">
                <div class="caption">
                  <template>{{ $t('Tax Identification Number') }}</template>
                </div>
                <editable
                  v-model="tax_address_json.tax_id"
                  :filter="'text'"
                  :type="'text'"
                  @edited="editTaxAddress()"
                ></editable>
              </v-flex>
            </v-layout>
          </template>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div style="word-break: break-word" class="pa-2">
          <template v-if="order.userid != 'salepage'">
            <span style="cursor:pointer" class="primary--text" @click="showModal = true"
              >{{ order.first_name }} {{ order.last_name }}</span
            >
            <v-btn
              v-if="order.app === 'facebook'"
              :href="'https://business.facebook.com' + order.inboxurl"
              target="_blank"
              small
              depressed
              round
              color="#3b5998"
              dark
            >
              <i class="fab fa-facebook-square mr-1"></i>
              {{ $t('View inbox') }}
            </v-btn>

            <v-btn
              v-if="$store.state.privilege.role !== 'admin'"
              color="primary"
              @click="goToAllInOneChat(order)"
              small
              depressed
              round
              dark
            >
              <v-icon class="mr-1" small>chat</v-icon>
              {{ $t('All in one chat button') }}
            </v-btn>
          </template>

          <template v-else>
            <span class="primary--text">Salepage User</span>
          </template>

          <template
            v-if="
              selectedBot.pageid == '103012211224246' ||
                selectedBot.pageid == '635426456938760' ||
                selectedBot.pageid == '613259679129221' ||
                selectedBot.pageid == '101857778024677'
            "
          >
            <template v-if="typeof shippingAddressPosition == 'string'">
              <edit-address
                v-model="order.nameaddress"
                :hasCopy="true"
                @edited="$emit('updateOrder', { type: 'save', order })"
              ></edit-address>
            </template>
            <template v-else>
              <a
                :href="
                  `https://maps.google.com?q=${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                "
                target="_blank"
                style="word-break: break-word"
              >
                https://maps.google.com?q={{
                  `${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                }}
              </a>
            </template>
          </template>
          <template v-else>
            <edit-address
              v-model="order.nameaddress"
              :type="'textarea'"
              @edited="$emit('updateOrder', { type: 'save', order })"
              :hasCopy="true"
            ></edit-address>
          </template>
          <template v-for="(Addon, i) in shopAddonValueJson">
            <template
              v-if="
                Addon.label !== '' &&
                  Addon.label !== 'Shipping Address' &&
                  Addon.label !== 'Tel.' &&
                  Addon.label !== 'Name' &&
                  Addon.message
              "
            >
              <div :key="i">
                <div class="caption mt-3">
                  {{ Addon.label }}
                </div>

                <div class="primary--text" v-if="Addon.label != isEditAddon">
                  {{ Addon.message ? Addon.message : '-' }}
                  <v-btn
                    fab
                    small
                    class="x-small"
                    flat
                    color="primary"
                    @click="editAddon(Addon.label)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </div>
                <div class="form-control" v-else-if="Addon.label == isEditAddon">
                  <input type="text" v-model="Addon.message" :name="Addon.label" />
                  <span class="text-error" v-if="errors.has(Addon.label)">{{
                    errors.first(Addon.label)
                  }}</span>
                  <div class="text-xs-center">
                    <v-btn color="grey" outline @click="cancelAddon">
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn color="primary" depressed @click="saveAddon">
                      {{ $t('Save') }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <div class="caption mt-3">{{ $t('Status') }}</div>
          <div class="primary--text">{{ order.userstatus ? order.userstatus : '-' }}</div>
          <template v-if="$store.state.centralPage.includes(selectedBot.pageid)">
            <div class="caption mt-3">{{ $t('Order status') }}</div>
            <div class="primary--text">{{ order.order_tags ? order.order_tags : '-' }}</div>
            <div class="caption mt-3">{{ $t('Live name') }}</div>
            <div class="primary--text">{{ order.livename ? order.livename : '-' }}</div>
          </template>
          <div class="caption mt-3">{{ $t('Tag') }}</div>
          <template v-if="tags.length > 0">
            <v-chip
              small
              v-for="(tag, index) in tags"
              :key="'tag_' + index"
              outline
              color="primary"
              disabled
              >{{ tag }}</v-chip
            >
          </template>
          <template v-else>
            <div class="primary--text">-</div>
          </template>
        </div>
        <v-divider></v-divider>

        <div class="pa-2">
          <template v-if="!(['fbpay'].includes(value.payment) && status.value == 'shipped')">
            <div v-if="status.value == 'canceled'" class="box-intent">
              <span>{{ $t('cancel') }}</span>
            </div>
            <multiselect
              v-else
              :disabled="
                isDisableStatus || value.zortout_ref !== null || status.value == 'canceled'
              "
              v-model="status"
              :options="orderStatusOptions"
              label="label"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
              track-by="label"
              @select="onConfirmCancelOrder"
            ></multiselect>
          </template>
          <template v-else>
            <v-layout>
              <v-flex>
                {{ $t('Order status') }}
              </v-flex>
              <v-flex class="text-xs-right primary--text">
                {{ status.label }}
              </v-flex>
            </v-layout>
          </template>
          <template v-if="order.k_bank_verify_slip_status_code">
            <h4
              v-if="order.k_bank_verify_slip_status_code === '0000'"
              style="text-align: center; background: chartreuse; padding: 3px; color: #000"
            >
              <v-icon style="font-size: 23px; color: #000; vertical-align: middle;">check</v-icon>
              <span style="vertical-align: middle;"> {{ $t('transfer_slip_is_correct') }} </span>
            </h4>
            <h4
              v-else-if="order.k_bank_verify_slip_status_code === 'DUPLICATED'"
              style="text-align: center; background: orangered; padding: 3px; color: #000"
            >
              <v-icon style="font-size: 23px; color: #000; vertical-align: middle;">close</v-icon>
              <span style="vertical-align: middle;">{{
                $t('transfer_slip_is_incorrect_duplicated')
              }}</span>
            </h4>
            <h4
              v-else-if="order.k_bank_verify_slip_status_code === 'INVALID_AMOUNT'"
              style="text-align: center; background: orangered; padding: 3px; color: #000"
            >
              <v-icon style="font-size: 23px; color: #000; vertical-align: middle;">close</v-icon>
              <span style="vertical-align: middle;">{{
                $t('transfer_slip_is_incorrect_amount')
              }}</span>
            </h4>
            <h4
              v-else-if="order.k_bank_verify_slip_status_code === 'INVALID_BANK_INFO'"
              style="text-align: center; background: orangered; padding: 3px; color: #000"
            >
              <v-icon style="font-size: 23px; color: #000; vertical-align: middle;">close</v-icon>
              <span style="vertical-align: middle;">{{ $t('transfer_slip_is_incorrect') }}</span>
            </h4>
            <h4 v-else style="text-align: center; background: orangered; padding: 3px; color: #000">
              <v-icon style="font-size: 23px; color: #000; vertical-align: middle;">close</v-icon>
              <span style="vertical-align: middle;"> {{ $t('transfer_slip_is_incorrect') }}</span>
            </h4>
            <div class="text-xs-center"><small>Verified by ZWIZ.AI</small></div>
          </template>
          <template
            v-if="
              order.status == 'shipped' &&
                !(
                  order.trackingno &&
                  order.shippingtype === 'scgexpress_charge' &&
                  selectedBot.scg_express_is_active
                )
            "
          >
            <div class="form-control pt-2">
              <textarea
                :disabled="value.zortout_ref !== null"
                type="text"
                v-model="order.trackingno"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', { type: 'save', order })"
                :disabled="
                  order.trackingno == null ||
                    order.trackingno == '' ||
                    order.trackingno.trim() == ''
                "
              >
                <i class="far fa-save"></i>
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', { type: 'send', order })"
                :disabled="
                  order.trackingno == null ||
                    order.trackingno == '' ||
                    order.trackingno.trim() == ''
                "
              >
                <i class="far fa-share-square"></i>
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else-if="order.status == 'canceled'">
            <div class="form-control pt-2">
              <input
                type="text"
                v-model="order.reason"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', { type: 'save', order, isSendReason: true })"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <i class="far fa-save"></i>
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', { type: 'send', order, isSendReason: true })"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <i class="far fa-share-square"></i>
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <!-- <template v-else>{{ order.trackingno }}</template> -->
        </div>
        <v-divider />
        <template v-if="order.trackingno && order.shipName == 'ninjavan_charge'">
          <div class="form-control px-2 pt-2 d-flex justify-space-between">
            <p class="text-xs-left grey--text ">{{ order.shiptype }}</p>
            <p class="text-xs-left grey--text ">{{ $t('Tracking') }}</p>
            <p class="text-xs-right grey--text ">{{ order.trackingno }}</p>
          </div>
          <div class="d-flex justify-end">
            <v-btn style="max-width:140px;" color="primary" small depressed round dark>
              {{ $t('check_delivery_status') }}
            </v-btn>
          </div>
        </template>
        <template v-if="order.trackingno && order.shippingtype == 'jtexpress_charge'">
          <div class="form-control px-2 pt-2 d-flex justify-space-between">
            <p class="text-xs-left grey--text ">{{ order.shippingType }}</p>
            <p class="text-xs-left grey--text ">{{ $t('Tracking') }}</p>
            <p class="text-xs-right grey--text ">{{ order.trackingno }}</p>
          </div>
          <div class="d-flex justify-end">
            <v-btn style="max-width:140px;" color="primary" small depressed round dark>
              {{ $t('check_delivery_status') }}
            </v-btn>
          </div>
        </template>
        <v-divider />
        <template v-if="['booking', 'waiting', 'confirm'].includes(order.shippop_status)">
          <div class="pa-2">
            <template v-if="order.shippop_order_status">
              <v-layout>
                <v-flex>สถานะการจัดส่ง Shippop</v-flex>
                <v-flex shrink class="text-xs-right">
                  <v-chip color="blue" disabled class="white--text" small>
                    {{ $t(`shippop_${order.shippop_order_status}`) }}
                  </v-chip>
                </v-flex>
              </v-layout>
            </template>

            <v-layout>
              <v-flex shrink>
                Shippop Tracking no.
              </v-flex>
              <v-flex class="text-xs-right">
                <a
                  :href="
                    `https://www.shippop.com/tracking/?tracking_code=${order.shippop_tracking_code}`
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ order.shippop_tracking_code }}
                </a>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                {{ $t('Tracking') }}
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.trackingno }}
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
        </template>

        <template v-if="order.packhai_ref">
          <div class="pa-2">
            <v-layout>
              <v-flex>
                สถานะการส่งกับ <img src="/static/img/packhai.png.webp" alt style="width: 80px"
              /></v-flex>
              <v-flex shrink class="text-xs-right">
                <v-chip color="blue" disabled class="white--text" small>
                  {{ (order.packhai_order_status || '-') | statusFormat }}
                </v-chip>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                Packhai ref.
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.packhai_ref }}
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                {{ $t('Tracking') }}
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.packhai_tracking_no }}
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
        </template>

        <template v-if="order.sokochan_ref">
          <div class="pa-2">
            <v-layout>
              <v-flex>
                สถานะการส่งกับ <img src="/static/img/sokochan.png" alt style="width: 80px"
              /></v-flex>
              <v-flex shrink class="text-xs-right">
                <v-chip color="blue" disabled class="white--text" small>
                  {{ (order.sokochan_order_status || '-') | statusFormat }}
                </v-chip>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                Sokochan ref.
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.sokochan_ref }}
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                {{ $t('Tracking') }}
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.sokochan_tracking_no }}
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
        </template>

        <template v-if="order.lalamove_info">
          <template v-if="!order.lalamove_info.order_ref">
            <v-btn
              @click="onCreateLalamoveQuotation(order)"
              small
              color="#F26722"
              depressed
              class="white--text"
            >
              จัดส่ง Lalamove
            </v-btn>
          </template>
          <div class="pa-2" v-else>
            <v-layout>
              <v-flex>
                สถานะการส่งกับ Lalamove
              </v-flex>
              <v-flex shrink class="text-xs-right">
                <v-chip color="blue" disabled class="white--text" small>
                  {{ (order.lalamove_info.order_status || '-') | statusFormat }}
                </v-chip>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                Lalamove ref.
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.lalamove_info.order_ref }}
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                {{ $t('Share link') }}
              </v-flex>
              <v-flex class="text-xs-right">
                <template v-if="!order.lalamove_info.share_link_url">-</template>
                <a :href="order.lalamove_info.share_link_url" v-else>Click</a>
              </v-flex>
            </v-layout>
          </div>
        </template>

        <template v-if="order.zortout_ref !== null">
          <div class="pa-2">
            <v-layout>
              <v-flex shrink>
                Zortout ref.
              </v-flex>
              <v-flex class="text-xs-right primary--text">
                {{ order.zortout_ref }}
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                {{ $t('Tracking') }}
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.trackingno }}
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
        </template>

        <template
          v-if="
            order.shippingtype == 'scgexpress_charge' &&
              order.trackingno &&
              selectedBot.scg_express_is_active
          "
        >
          <div class="pa-2">
            <v-layout>
              <v-flex shrink>
                {{ $t('Tracking') }}
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.trackingno }}
              </v-flex>
            </v-layout>
            <v-layout class="mt-1">
              <v-flex class="text-xs-right primary--text">
                <v-btn
                  color="primary"
                  :loading="loadingCheckStatusScg"
                  class="ma-0"
                  small
                  @click="checkStatusScgExpress(order.id)"
                >
                  {{ $t('check_delivery_status') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
        </template>

        <v-layout>
          <v-flex>
            <div class="pa-2">
              <div>
                <template v-if="shippingType && shippingType == 'cod_charge'">
                  {{ $t('cod_charge') }}
                </template>
                <template v-else>
                  <template v-if="order.payment == 'banktransfer' || order.payment == 'transfer'">
                    {{ $t('Bank Transfer') }}
                  </template>
                  <template v-else-if="order.payment == 'cod'">{{ $t('cod_charge') }}</template>
                  <template v-else-if="order.payment == 'qrcode'">Qr Code</template>
                  <template v-else-if="order.payment == 'fbpay'">
                    {{ $t('Mobile Banking') }}
                  </template>
                  <template v-else-if="order.payment == 'credit'">{{ $t('PayPal') }}</template>
                  <template v-else-if="order.payment == 'gbcredit'">{{
                    $t('Credit card')
                  }}</template>
                  <template v-else
                    >{{ order.payment }}
                    <span v-if="order.payment == '2c2p' && order.jsonvalue">
                      {{
                        ': ' +
                          (JSON.parse(order.jsonvalue).payment_channel
                            ? JSON.parse(order.jsonvalue).payment_channel
                            : '-')
                      }}
                    </span>
                  </template>
                </template>
                <div class="caption" v-if="order.transactionid">{{ $t(order.transactionid) }}</div>
              </div>
              {{ order.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </div>
          </v-flex>
          <v-flex>
            <div class="pa-2">
              <div style="text-align: right">
                <PrintAllCoversCentral
                  v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  :orders="[order]"
                  :circle="true"
                  @onPrinCover="onPrinCover(true, $event)"
                  style="display: inline-block"
                ></PrintAllCoversCentral>
                <print-all-covers
                  v-else
                  :orders="[order]"
                  :circle="true"
                  @onPrinCover="onPrinCover(false, $event)"
                  style="display: inline-block"
                ></print-all-covers>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <template v-if="cart_remark">
          <v-divider />
          <div class="pa-2">
            <div
              v-if="
                ['176922345693076', '809510349133469', '103876431747147'].includes(
                  selectedBot.pageid
                )
              "
            >
              ขายโดย
            </div>
            <div class="font-weight-bold primary--text">
              {{ cart_remark }}
            </div>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <template v-if="order.payment === 'transfer' || order.payment === 'fbpay'">
      <div class="hr"></div>
      <a href="javascript:void(0);" @click="showDetail = !showDetail" style="text-decoration: none">
        <div class="text-xs-center" style="margin: 10px auto">
          {{ $t('Click to view slip') }}
          <i
            class="fas"
            :class="{ 'fa-chevron-down': !showDetail, 'fa-chevron-up': showDetail }"
          ></i>
        </div>
      </a>
      <div
        v-show="showDetail"
        style="margin-bottom: 0; background: rgb(253, 253, 253); border-bottom-left-radius: 10px"
      >
        <template v-if="showDetail">
          <template v-if="order.note == 'base64'">
            <load-base64 :orderid="order.id" :key="'slip_' + order.id"></load-base64>
          </template>
          <template v-else>
            <div class="text-xs-center">
              <uploadfile
                ref="answer"
                v-model="slipUrl"
                @onUploaded="onUploaded"
                v-validate
                :multiple="false"
                :show-only-button="true"
                :verifyData.sync="verifyData"
                :disabled="images.length >= 3"
              ></uploadfile>
            </div>
            <template v-if="order.note">
              <v-container grid-list-md text-xs-center>
                <v-layout row wrap style="justify-content: center;">
                  <v-flex xs3 v-for="image in images" :key="image">
                    <image-editable :image="image" @onDelete="onDeleteSlip" />
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
          </template>
        </template>
      </div>
    </template>

    <v-dialog persistent v-model="lalamove.show" max-width="1000">
      <v-card v-if="lalamove.order && lalamove.order.lalamove_info">
        <div class="text-xs-right">
          <v-btn flat small fab @click="onCancelLalamove" :loading="lalamove.loading">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="mb-3">
            <v-layout>
              <v-flex class="primary--text pt-2">
                จาก
              </v-flex>
              <v-flex shrink>
                <v-btn
                  color="primary"
                  small
                  depressed
                  @click="showFromAddress = true"
                  :loading="loadingdistances"
                >
                  แก้ไข
                </v-btn>
              </v-flex>
            </v-layout>

            <div class="pa-2 z-border-red">
              <template
                v-if="
                  lalamove.order.lalamove_info.stops_json &&
                    lalamove.order.lalamove_info.stops_json.length > 0
                "
              >
                {{ lalamove.order.lalamove_info.stops_json[0].addresses.th_TH.displayString }}
              </template>
            </div>
          </div>

          <div class="form-control" v-if="lalamove.order.lalamove_info.requester_contact_json">
            ติดต่อผู้ส่ง
            <v-layout wrap>
              <v-flex xs6 class="px-1">
                <input
                  type="text"
                  v-model="lalamove.order.lalamove_info.requester_contact_json.name"
                  placeholder="ชื่อ"
                />
              </v-flex>
              <v-flex xs6 class="px-1">
                <input
                  type="tel"
                  v-model="lalamove.order.lalamove_info.requester_contact_json.phone"
                  placeholder="เบอร์"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div class="mb-3">
            <v-layout>
              <v-flex class="primary--text pt-2">
                ถึง
              </v-flex>
              <v-flex shrink>
                <v-btn
                  color="primary"
                  small
                  depressed
                  @click="showToAddress = true"
                  :loading="loadingdistances"
                >
                  แก้ไข
                </v-btn>
              </v-flex>
            </v-layout>

            <div class="pa-2 z-border-red">
              <template
                v-if="
                  lalamove.order.lalamove_info.stops_json &&
                    lalamove.order.lalamove_info.stops_json.length > 1
                "
              >
                {{ lalamove.order.lalamove_info.stops_json[1].addresses.th_TH.displayString }}
              </template>
            </div>
          </div>

          <template
            v-if="
              lalamove.order.lalamove_info.deliveries_json &&
                lalamove.order.lalamove_info.deliveries_json.length > 0
            "
          >
            <div class="form-control">
              เพิ่มรายละเอียดถึงคนขับ
              <textarea row="5" v-model="lalamove.order.lalamove_info.deliveries_json[0].remarks">
              </textarea>
            </div>

            <div class="form-control">
              ติดต่อผู้รับ
              <v-layout warp>
                <v-flex xs6 class="px-1">
                  <input
                    type="text"
                    v-model="lalamove.order.lalamove_info.deliveries_json[0].toContact.name"
                    placeholder="ชื่อ"
                  />
                </v-flex>
                <v-flex xs6 class="px-1">
                  <input
                    class="px-1"
                    type="tel"
                    v-model="lalamove.order.lalamove_info.deliveries_json[0].toContact.phone"
                    placeholder="เบอร์"
                  />
                </v-flex>
              </v-layout>
            </div>
          </template>
        </v-card-text>
        <v-divider />

        <v-checkbox
          class="ml-3"
          v-model="lalamove.cod"
          color="primary"
          style="font-size: 14px;"
          label="จัดเก็บเงินปลายทาง"
          :value="lalamove.cod"
        ></v-checkbox>

        <v-divider />
        <v-card-text>
          <div>ตั้งเวลาส่ง (Optional)</div>
          <v-layout wrap class="mb-5">
            <v-flex class="form-control" xs6 :class="{ 'has-error': errors.has('enddate') }">
              <v-menu
                ref="openStartDate"
                v-model="openStartDate"
                :close-on-content-click="false"
                full-width
                max-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <input
                    type="text"
                    class="form-control browser-default"
                    :placeholder="$t('Date')"
                    readonly
                    v-model="lalamove.date"
                    v-on="on"
                    clearable
                    small
                  />
                </template>
                <v-date-picker
                  color="primary"
                  v-model="lalamove.date"
                  @input="
                    openStartDate = false
                    checkTime()
                  "
                  :min="nowDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 class="pl-1">
              <time-picker
                :key="`setendtime_${timestamp}`"
                v-model="lalamove.time"
                full-width
                :hourRange="hourRange.length === 0 ? null : hourRange"
                format="HH:mm"
                :placeholder="$t('Time')"
                :hide-clear-button="true"
              ></time-picker>
            </v-flex>
            <v-flex xs2>
              <v-btn
                fab
                flat
                small
                color="primary"
                style="height: 35px; width: 35px"
                @click="
                  lalamove.date = null
                  lalamove.time = null
                  changeTimestamp()
                "
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <div class="text-xs-center">
            <v-btn color="grey" outline @click="onCancelLalamove" :loading="lalamove.loading">
              {{ $t('cancel') }}
            </v-btn>

            <v-btn color="primary" depressed @click="onSummaryLalamove" :loading="lalamove.loading">
              {{ $t('Next') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="lalamove.showSummarize" max-width="1000">
      <v-card v-if="lalamove.order && lalamove.order.lalamove_info">
        <div class="text-xs-right">
          <v-btn flat small fab @click="onBackLalamove" :loading="lalamove.loading">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="mb-3">
            <v-layout>
              <v-flex class="primary--text pt-2">
                จาก
              </v-flex>
            </v-layout>
            <div class="pa-2 z-border-red">
              <template
                v-if="
                  lalamove.order.lalamove_info.stops_json &&
                    lalamove.order.lalamove_info.stops_json.length > 0
                "
              >
                {{ lalamove.order.lalamove_info.stops_json[0].addresses.th_TH.displayString }}
              </template>
            </div>
          </div>

          <div class="form-control" v-if="lalamove.order.lalamove_info.requester_contact_json">
            ติดต่อผู้ส่ง
            <v-layout wrap>
              <v-flex xs6 class="px-1">
                {{ lalamove.order.lalamove_info.requester_contact_json.name }}
              </v-flex>
              <v-flex xs6 class="px-1">
                {{ lalamove.order.lalamove_info.requester_contact_json.phone }}
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div class="mb-3">
            <v-layout>
              <v-flex class="primary--text pt-2">
                ถึง
              </v-flex>
            </v-layout>

            <div class="pa-2 z-border-red">
              <template
                v-if="
                  lalamove.order.lalamove_info.stops_json &&
                    lalamove.order.lalamove_info.stops_json.length > 1
                "
              >
                {{ lalamove.order.lalamove_info.stops_json[1].addresses.th_TH.displayString }}
              </template>
            </div>
          </div>

          <template
            v-if="
              lalamove.order.lalamove_info.deliveries_json &&
                lalamove.order.lalamove_info.deliveries_json.length > 0
            "
          >
            <div class="form-control">
              เพิ่มรายละเอียดถึงคนขับ
              <div class="mb-3">
                {{ lalamove.order.lalamove_info.deliveries_json[0].remarks }}
              </div>
            </div>

            <div class="form-control">
              ติดต่อผู้รับ
              <v-layout wrap>
                <v-flex xs6 class="px-1">
                  {{ lalamove.order.lalamove_info.deliveries_json[0].toContact.name }}
                </v-flex>
                <v-flex xs6 class="px-1">
                  {{ lalamove.order.lalamove_info.deliveries_json[0].toContact.phone }}
                </v-flex>
              </v-layout>
            </div>
          </template>
        </v-card-text>
        <v-divider />
        <template v-if="dateTimePreview">
          <v-card-text>
            <div>
              ตั้งเวลาส่ง (Optional)
              <div>
                {{ dateTimePreview | DateFormat('DD MMM YYYY HH:mm a') }}
              </div>
            </div>
          </v-card-text>
          <v-divider />
        </template>
        <v-card-text>
          <div>ค่าจัดส่ง</div>
          <div>
            {{ lalamove.totalFeeCurrency }} {{ lalamove.totalFee }} บวกค่าส่งเพิ่มเติมจากทางร้าน
            {{ lalamove.totalFeeCurrency }}
            {{ lalamove_addon_json ? lalamove_addon_json.shop_fee : 0 }} รวมเป็น
            {{ lalamove.totalFeeCurrency }}
            {{
              parseInt(lalamove.totalFee) +
                parseInt(lalamove_addon_json ? lalamove_addon_json.shop_fee : 0)
            }}
          </div>
          {{ lalamove.cod ? ' ( เก็บเงินปลายทาง )' : '' }}

          <div class="text-xs-center">
            <v-btn color="grey" outline @click="onBackLalamove" :loading="lalamove.loading">
              {{ $t('Back') }}
            </v-btn>
            <v-btn
              color="primary"
              depressed
              @click="onPlaceOrderLalamove"
              :loading="lalamove.loading"
            >
              {{ $t('Submit') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showStatusScgExpress" max-width="500">
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6>
              <h3>{{ $t('delivery_status') }}</h3>
            </v-flex>
            <v-flex xs6>
              <div class="text-xs-right">
                <v-btn
                  flat
                  small
                  fab
                  @click="showStatusScgExpress = false"
                  :loading="lalamove.loading"
                >
                  <v-icon>
                    close
                  </v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>

          <div
            v-for="(item, index) in dataCheckStatusScgExpress.tracking_data"
            :key="'dataCheckStatusScgExpress_' + index"
          >
            <v-layout row wrap>
              <v-flex xs6 class="mb-2"
                ><span class="primary--text">{{ $t('branch_code') }}:</span> {{ item.branch_code }}
              </v-flex>
              <v-flex xs6 class="mb-2"
                ><span class="primary--text">{{ $t('branch_name') }}: </span> {{ item.branch_name }}
              </v-flex>
              <v-flex xs6 class="mb-2">
                <span class="primary--text">{{ $t('date') }}:</span> {{ item.date_input }}
              </v-flex>
              <v-flex xs6 class="mb-2">
                <span class="primary--text">{{ $t('status_code') }}:</span> {{ item.status_code }}
              </v-flex>
              <v-flex xs6 class="mb-2"
                ><span class="primary--text">{{ $t('status') }}: </span> {{ item.status_name }}
              </v-flex>
            </v-layout>
          </div>

          <div class="text-xs-center mt-3">
            <v-btn color="primary" depressed @click="showStatusScgExpress = false">
              {{ $t('close') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template v-if="lalamove.order && lalamove.order.lalamove_info">
      <select-gmap
        v-model="showFromAddress"
        v-if="!loadingdistances && lalamove.order.lalamove_info.stops_json.length > 0"
        :location="lalamove.order.lalamove_info.stops_json[0].location"
        @changeLocation="changeLocation('from', $event)"
      ></select-gmap>
      <select-gmap
        v-model="showToAddress"
        v-if="!loadingdistances && lalamove.order.lalamove_info.stops_json.length > 1"
        :location="lalamove.order.lalamove_info.stops_json[1].location"
        @changeLocation="changeLocation('to', $event)"
      ></select-gmap>
    </template>
    <v-dialog v-model="showModal" width="800">
      <v-card>
        <customer-detail
          v-if="showModal"
          :loaduser="false"
          :getuseronly="true"
          :key="order.userid"
          v-model="order"
        >
          <div slot="header" class="text-xs-right">
            <v-btn flat fab small class="extra-small" @click="showModal = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </customer-detail>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="showModal = false">{{ $t('cancel') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import mixin from './OrderSummaryItem.js'
import LoadBase64 from './LoadBase64'
import EditAddress from './EditAddress'
import Multiselect from 'vue-multiselect'
import TimePicker from '@/components/elements/TimePicker.vue'
import CustomerDetail from '@/components/view/analytics/CustomerDetail.vue'
import ImageEditable from '@/components/elements/ImageEditable'

export default {
  mixins: [mixin],
  components: {
    'load-base64': LoadBase64,
    EditAddress: EditAddress,
    Multiselect,
    TimePicker,
    CustomerDetail,
    ImageEditable
  },
  filters: {
    statusFormat: function(value) {
      switch (value.toString()) {
        case '10':
          return 'เปิดออเดอร์'
        case '20':
          return 'ชำระยอดแล้ว'
        case '30':
          return 'ตรวจสอบยอดแล้ว'
        case '40':
          return 'กำลังแพ็ค'
        case '50':
          return 'แพ็คเรียบร้อย'
        case '60':
          return 'เตรียมจัดส่ง'
        case '70':
          return 'จัดส่งแล้ว'
        case '90':
          return 'ยกเลิก'
        default:
          return '-'
      }
    }
  },
  data() {
    return {
      showModal: false,
      date: null
    }
  },
  mounted() {},
  methods: {
    sendInvoicePDF(val) {
      let vm = this
      const lang = this.currentLang === 'th' ? 'th' : 'en'
      const url = `${location.origin}/${lang}/pdf_invoice/${this.selectedBot.pageid}/${val.type}/${val.order.id}`
      let data = {
        pageid: this.selectedBot.pageid,
        userid: val.order.userid,
        app: 'facebook',
        messagetype: 'json',
        messagevalue: `[[{"text":"${
          val.type == 'receipt' ? this.$t('Receipt') : this.$t('Tax invoice')
        }","buttons":[{"title":"${this.$t(
          'print'
        )}","type":"web_url","url":"${url}"}],"type":"button"}]]`
      }
      api.sendMessage(data, function(error, response) {
        if (error) {
          vm.$swal.fire({
            title: 'ไม่สามารถส่งข้อความได้',
            type: 'error',
            text: `${response.error_code} ${response.reason}`
          })
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.openBill-border {
  border: 1px solid rgb(0, 0, 0);
  padding: 5px 10px;
  color: rgb(0, 0, 0);
  display: inline-block;
  border-radius: 40px;
  margin: 1px;
}
.box-intent {
  background-color: white;
  border: 1px solid #e8e5e5;
  border-radius: 5px;
  width: 100%;
  padding: 12px 20px;
  margin: 0px 0 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 20px 20px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SummaryItem.vue